
import Vue from 'vue'

export default Vue.extend({
    props: {
        index: Number,
        clause: Object as () => Connex.VM.Clause,
        output: Object as () => Connex.Thor.Transaction.Receipt['outputs'][number]
    },
    data: () => {
        return { tab: 0 }
    },
    computed: {
        events(): Connex.VM.Event[] {
            return this.output ? this.output.events : []
        },
        transfers(): TransferItemData[] {
            return this.output ? this.output.transfers.map(t => ({
                from: t.sender,
                to: t.recipient,
                amount: t.amount
            })) : []
        },
        type(): string {
            if (this.clause.to) {
                if (this.clause.data === '0x') {
                    return 'transfer'
                } else {
                    return 'call'
                }
            } else {
                return 'create'
            }
        },
        showTabs(): boolean {
            return this.type !== 'transfer' || this.events.length > 0 || this.transfers.length > 0
        }
    }
})
